import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { getTrustIcons } from '../../domain/policies/publicationCode'
import styles from './TrustIcons.module.css'

export function TrustIcons() {
  const intl = useIntl()
  const publicationCode = useConfiguration('publicationCode')
  const trustIcons = getTrustIcons(publicationCode)

  return (
    <div className={styles.trustIconsContainer}>
      <Typography variant="body-l-bold-tight" className={styles.title}>
        {intl.formatMessage({ id: 'checkout_steps_trust_icons_title' })}
      </Typography>
      <div className={styles.trustIcons}>
        {trustIcons?.map(affiliate => (
          <img key={affiliate.altText} src={affiliate.image} alt={affiliate.altText} loading="lazy" className={styles.image} />
        ))}
      </div>
    </div>
  )
}
